<template>
  <q-layout view="hHh lpr fFf">
    <q-header bordered class="bg-grey-1 text-dark">
      <q-toolbar>
        <q-toolbar-title>
          <router-link to="/">
            <img
              src="assets/images/logo.png"
              width="247"
              height="84"
              alt="プレチェク"
              style="height: 54px; width: auto; vertical-align: middle"
            />
          </router-link>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>

    <q-page-container>
      <q-page class="q-mx-auto q-pa-md flex items-center" style="max-width: var(--q-size-md)">
        <router-view />
      </q-page>
    </q-page-container>

    <q-footer bordered class="bg-grey-1 text-dark">
      <q-toolbar class="justify-center">
        <div>Copyright(c) 2021 Tryit Co., Ltd All Rights Reserved.</div>
      </q-toolbar>
    </q-footer>
  </q-layout>
</template>
